import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Transition as _Transition, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: "buyerDirectoryOptions",
  class: "o-panel"
}
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "o-panel--spacedChildrenLarge" }
const _hoisted_4 = { class: "o-panel--spacedChildrenSmall" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", {
  class: "a-heading3",
  textContent: 'Type'
}, null, -1 /* HOISTED */)
const _hoisted_6 = { class: "o-tags o-searchFilters__tags" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = { class: "o-panel--spacedChildrenSmall" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", {
  class: "a-heading3",
  textContent: 'Postnummer'
}, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "o-panel--spacedChildrenSmall" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", {
  class: "a-heading3",
  textContent: 'Pris'
}, null, -1 /* HOISTED */)
const _hoisted_13 = { class: "o-panel--spacedChildrenSmall" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", {
  class: "a-heading3",
  textContent: 'Boligstørrelse'
}, null, -1 /* HOISTED */)
const _hoisted_15 = { class: "o-panel--spacedChildrenSmall" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", {
  class: "a-heading3",
  textContent: 'Kommentar'
}, null, -1 /* HOISTED */)
const _hoisted_17 = ["textContent"]
const _hoisted_18 = ["textContent"]
const _hoisted_19 = { class: "o-buttons o-subPanel__actions--singleCTA o-subPanel__actions--additional" }
const _hoisted_20 = ["textContent"]
const _hoisted_21 = {
  key: "buyerDirectoryName",
  class: "o-panel"
}
const _hoisted_22 = ["textContent"]
const _hoisted_23 = { class: "o-panel--spacedChildrenLarge" }
const _hoisted_24 = { class: "a-card o-panel--spacedChildrenSmall" }
const _hoisted_25 = { class: "o-tags o-searchFilters__tags" }
const _hoisted_26 = {
  key: 0,
  class: "o-panel--spacedChildrenSmall"
}
const _hoisted_27 = ["textContent"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = { class: "o-buttons o-subPanel__actions" }
const _hoisted_30 = ["textContent"]
const _hoisted_31 = ["href"]
const _hoisted_32 = ["textContent"]
const _hoisted_33 = {
  key: 1,
  class: "o-panel--spacedChildrenSmall"
}
const _hoisted_34 = ["textContent"]
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "o-buttons o-subPanel__actions" }
const _hoisted_37 = ["textContent"]
const _hoisted_38 = ["textContent"]
const _hoisted_39 = {
  key: "buyerDirectoryNameSuccess",
  class: "o-panel"
}
const _hoisted_40 = ["textContent"]
const _hoisted_41 = { class: "a-card" }
const _hoisted_42 = { class: "o-panel--spacedChildrenSmall" }
const _hoisted_43 = ["textContent"]
const _hoisted_44 = { class: "o-tags o-searchFilters__tags" }
const _hoisted_45 = { class: "a-confirmationNotice a-confirmationNotice--paddingBottom" }
const _hoisted_46 = { class: "a-confirmationNotice__checkmark" }
const _hoisted_47 = ["textContent"]
const _hoisted_48 = ["href", "textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_tag = _resolveComponent("m-tag")!
  const _component_m_input = _resolveComponent("m-input")!
  const _component_m_range_slider = _resolveComponent("m-range-slider")!
  const _component_m_textarea = _resolveComponent("m-textarea")!
  const _component_a_icon = _resolveComponent("a-icon")!
  const _component_portal = _resolveComponent("portal")!

  return ($options.show)
    ? (_openBlock(), _createBlock(_component_portal, {
        key: 0,
        to: "modal"
      }, {
        default: _withCtx(() => [
          _createVNode(_Transition, {
            name: `o-panel--${$data.currentDirection}`
          }, {
            default: _withCtx(() => [
              (!_ctx.currentPanel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("h2", {
                      class: "a-heading2 o-panel__heading",
                      textContent: _toDisplayString($props.texts.stepOne.headline)
                    }, null, 8 /* PROPS */, _hoisted_2),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("div", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tagOptions, (key, value) => {
                            return (_openBlock(), _createBlock(_component_m_tag, {
                              key: key,
                              checked: 
                                    _ctx.currentTags.some(
                                        (x) =>
                                            x.value === value,
                                    )
                                ,
                              onInput: ($event: any) => (
                                    $options.updateTags({
                                        key: key,
                                        value: value,
                                    })
                                )
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(typeof value === 'string'
                                        ? $options.capitalize(value)
                                        : value), 1 /* TEXT */)
                              ], undefined, true),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["checked", "onInput"]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        ($data.errors.propertyType)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_7, [
                              _createElementVNode("small", {
                                class: "a-error m-input__error",
                                textContent: _toDisplayString($data.errors.propertyType)
                              }, null, 8 /* PROPS */, _hoisted_8)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_m_input, {
                          modelValue: $data.form.zipcode,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.form.zipcode) = $event)),
                          autocomplete: 'postal-code',
                          error: $data.errors.zipCode,
                          class: "o-searchFilters__input",
                          label: $props.formData.zipCodeLabel,
                          onInput: _cache[1] || (_cache[1] = ($event: any) => ($options.updateInput('zipcode', $event)))
                        }, null, 8 /* PROPS */, ["modelValue", "error", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode(_component_m_range_slider, {
                          modelValue: $data.form.price,
                          "onUpdate:modelValue": [
                            _cache[2] || (_cache[2] = ($event: any) => (($data.form.price) = $event)),
                            _cache[3] || (_cache[3] = ($event: any) => ($options.updateRange('price', $event)))
                          ],
                          class: "o-searchFilters__rangeSlider",
                          append: $props.priceFilter.postFix,
                          "aria-label": $props.priceFilter.name,
                          "complex-interval": $data.priceComplexInterval,
                          "infinity-indicator": $props.priceFilter.infinityIndicator,
                          interval: $props.priceFilter.multiplier,
                          max: $props.priceFilter.max,
                          min: $props.priceFilter.min
                        }, null, 8 /* PROPS */, ["modelValue", "append", "aria-label", "complex-interval", "infinity-indicator", "interval", "max", "min"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_m_range_slider, {
                          modelValue: $data.form.size,
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => (($data.form.size) = $event)),
                            _cache[5] || (_cache[5] = ($event: any) => ($options.updateRange('size', $event)))
                          ],
                          class: "o-searchFilters__rangeSlider",
                          append: 'm²',
                          "aria-label": 'Størrelse',
                          "infinity-indicator": true,
                          interval: 10,
                          max: $data.houseAreaMax,
                          min: $data.houseAreaMin
                        }, null, 8 /* PROPS */, ["modelValue", "max", "min"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode(_component_m_textarea, {
                          modelValue: $data.form.comment,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.form.comment) = $event)),
                          label: $props.formData.commentLabel,
                          error: $data.errors.comment,
                          onInput: _cache[7] || (_cache[7] = ($event: any) => ($options.updateInput('comment', $event)))
                        }, null, 8 /* PROPS */, ["modelValue", "label", "error"])
                      ]),
                      _createVNode(_Transition, {
                        name: "fade",
                        mode: "out-in"
                      }, {
                        default: _withCtx(() => [
                          ($data.errors.generalErrorMessage)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: "error",
                                class: "a-error o-subPanel__helpText",
                                textContent: _toDisplayString($data.errors.generalErrorMessage)
                              }, null, 8 /* PROPS */, _hoisted_17))
                            : (_openBlock(), _createElementBlock("span", {
                                key: "help",
                                class: "a-small o-subPanel__helpText",
                                textContent: _toDisplayString($props.texts.stepOne.helpText)
                              }, null, 8 /* PROPS */, _hoisted_18))
                        ], undefined, true),
                        _: 1 /* STABLE */
                      }),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["m-button", { isLoading: $data.isLoading }]),
                          onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.nextPanel('buyerDirectoryName')))
                        }, [
                          _createElementVNode("span", {
                            class: "m-button__text",
                            textContent: _toDisplayString($props.texts.stepOne.buttonText)
                          }, null, 8 /* PROPS */, _hoisted_20)
                        ], 2 /* CLASS */)
                      ])
                    ])
                  ]))
                : (_ctx.currentPanel === 'buyerDirectoryName')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("h2", {
                        class: "a-heading2 o-panel__heading",
                        textContent: _toDisplayString($props.texts.stepTwo.headline)
                      }, null, 8 /* PROPS */, _hoisted_22),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_m_input, {
                            modelValue: $data.form.name,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.form.name) = $event)),
                            class: "o-searchFilters__input",
                            autocomplete: 'name',
                            label: $props.formData.nameLabel,
                            error: $data.errors.name,
                            onInput: _cache[10] || (_cache[10] = ($event: any) => ($options.updateInput('name', $event)))
                          }, null, 8 /* PROPS */, ["modelValue", "label", "error"]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_25, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.currentFilters, (tag, tagIndex) => {
                                return (_openBlock(), _createBlock(_component_m_tag, {
                                  key: tagIndex,
                                  disabled: true,
                                  class: "isDisabled"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($options.capitalize(tag.value)), 1 /* TEXT */)
                                  ], undefined, true),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ])
                        ]),
                        (!$props.isLoggedIn)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _createElementVNode("p", {
                                class: "a-label a-label--secondaryFont",
                                textContent: _toDisplayString($props.texts.stepTwo.isNotLoggedInBodyText)
                              }, null, 8 /* PROPS */, _hoisted_27),
                              ($props.consent)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "a-small a-small--allowBreak o-fields__field",
                                    innerHTML: $props.consent.purposeText
                                  }, null, 8 /* PROPS */, _hoisted_28))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "m-button m-button--transparent",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => ($options.previousPanel('')))
                                }, [
                                  _createVNode(_component_a_icon, {
                                    class: "m-button__icon",
                                    name: "arrow_back"
                                  }),
                                  _createElementVNode("span", {
                                    class: "m-button__text",
                                    textContent: _toDisplayString($props.texts.backButton)
                                  }, null, 8 /* PROPS */, _hoisted_30)
                                ]),
                                _createElementVNode("a", {
                                  href: $props.texts.stepTwo.signupLoginButtonLink,
                                  class: "m-button"
                                }, [
                                  _createElementVNode("span", {
                                    class: "m-button__text",
                                    textContent: _toDisplayString($props.texts.stepTwo.signupLoginButtonText)
                                  }, null, 8 /* PROPS */, _hoisted_32)
                                ], 8 /* PROPS */, _hoisted_31)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _createElementVNode("div", null, [
                                _createElementVNode("p", {
                                  class: "a-label a-label--secondaryFont",
                                  textContent: _toDisplayString($props.texts.stepTwo.isLoggedInBodyText)
                                }, null, 8 /* PROPS */, _hoisted_34)
                              ]),
                              ($props.consent)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "a-small a-small--allowBreak o-fields__field",
                                    innerHTML: $props.consent.purposeText
                                  }, null, 8 /* PROPS */, _hoisted_35))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "m-button m-button--transparent",
                                  onClick: _cache[12] || (_cache[12] = ($event: any) => ($options.previousPanel('')))
                                }, [
                                  _createVNode(_component_a_icon, {
                                    class: "m-button__icon",
                                    name: "arrow_back"
                                  }),
                                  _createElementVNode("span", {
                                    class: "m-button__text",
                                    textContent: _toDisplayString($props.texts.backButton)
                                  }, null, 8 /* PROPS */, _hoisted_37)
                                ]),
                                _createElementVNode("button", {
                                  type: "submit",
                                  class: _normalizeClass(["m-button", { isLoading: $data.isLoading }]),
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => ($options.onSubmit('buyerDirectoryNameSuccess')))
                                }, [
                                  _createElementVNode("span", {
                                    class: "m-button__text",
                                    textContent: _toDisplayString($props.texts.stepTwo.saveButtonText)
                                  }, null, 8 /* PROPS */, _hoisted_38)
                                ], 2 /* CLASS */)
                              ])
                            ]))
                      ])
                    ]))
                  : (_ctx.currentPanel === 'buyerDirectoryNameSuccess')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _createElementVNode("h2", {
                          class: "a-heading2 o-panel__heading",
                          textContent: _toDisplayString($props.texts.stepFour.headline)
                        }, null, 8 /* PROPS */, _hoisted_40),
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("p", {
                              class: "a-label a-label--secondary",
                              textContent: _toDisplayString($data.form.name)
                            }, null, 8 /* PROPS */, _hoisted_43),
                            _createElementVNode("div", _hoisted_44, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.currentFilters, (tag, tagIndex) => {
                                return (_openBlock(), _createBlock(_component_m_tag, {
                                  key: tagIndex,
                                  disabled: true,
                                  class: "isDisabled"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString($options.capitalize(tag.value)), 1 /* TEXT */)
                                  ], undefined, true),
                                  _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_a_icon, { name: "check" })
                          ]),
                          _createElementVNode("span", {
                            class: "a-label",
                            textContent: _toDisplayString($props.texts.stepFour.bodyText)
                          }, null, 8 /* PROPS */, _hoisted_47)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("a", {
                            class: "a-anchor a-anchor--secondary",
                            href: $props.texts.stepFour.profileLink,
                            textContent: _toDisplayString($props.texts.stepFour.profileLinkText)
                          }, null, 8 /* PROPS */, _hoisted_48)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
            ], undefined, true),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["name"])
        ], undefined, true),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}